export const MATURITY_LABELS: Record<number, string> = {
  1: 'Observador',
  2: 'Experimentador',
  3: 'Operacional',
  4: 'Integrado',
  5: 'Autônomo',
}

export const REVENUE_LABELS: Record<string, string> = {
  ate_500k: 'Até R$500k',
  '500k_2m': 'R$500k–2M',
  '2m_10m': 'R$2M–10M',
  '10m_50m': 'R$10M–50M',
  '50m_200m': 'R$50M–200M',
  acima_200m: 'Acima de R$200M',
}

export const VERTICAL_LABELS: Record<string, string> = {
  moda: 'Moda',
  beleza: 'Beleza',
  casa: 'Casa',
  eletronicos: 'Eletrônicos',
  alimentos: 'Alimentos',
  saude: 'Saúde',
  outro: 'Outro',
}

export const PATH_LABELS: Record<string, string> = {
  ai_user: 'Usa IA',
  non_ai_user: 'Não usa IA',
}

export const TEAM_SIZE_LABELS: Record<string, string> = {
  '1_2': '1–2',
  '3_5': '3–5',
  '6_15': '6–15',
  '16_50': '16–50',
  mais_50: '50+',
}

export interface PanoramaResponseRow {
  id: string
  email: string
  revenueRange: string
  teamSize: string
  vertical: string
  verticalOther: string | null
  respondentPath: string
  maturityLevel: number
  completedAt: string
  wantsReport: boolean
  wantsPersonalizedAnalysis: string | null
}

export interface Pagination {
  page: number
  totalPages: number
  total: number
}

export interface Filters {
  maturityLevel: string
  respondentPath: string
  revenueRange: string
  vertical: string
}

export interface Stats {
  total: number
  avgMaturity: number
  byPath: Record<string, number>
  byLevel: Record<string, number>
}
